import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TableLazyLoadEvent } from 'primeng/table';
import { Observable, catchError, throwError } from 'rxjs';
import { getHttpErrorTranslationKeys } from 'src/app/utils/errors/http-error';
import { environment } from 'src/environments/environment';
import { LazyListDto } from '../models/LazyListDto';
import { MessageCenterService } from './message-center.service';

@Injectable({
  providedIn: 'root'
})
export class GenericService<T> {
  private http = inject(HttpClient);
  private messageCenterService = inject(MessageCenterService);
  private translate = inject(TranslateService);

  context!: string;

  setContext(context: string) {
    this.context = context;
  }

  lazyLoad(event: TableLazyLoadEvent): Observable<LazyListDto<T>> {
    return this.http
      .post<LazyListDto<T>>(`${environment.apiUrl}/${this.context}/getLazy`, {
        lazyLoadEvent: JSON.stringify(event)
      })
      .pipe(catchError((error: HttpErrorResponse) => this.handleError(error)));
  }

  findAll(): Observable<T[]> {
    return this.http
      .get<T[]>(`${environment.apiUrl}/${this.context}`)
      .pipe(catchError((error: HttpErrorResponse) => this.handleError(error)));
  }

  delete(id: number): Observable<T> {
    return this.http
      .delete<T>(`${environment.apiUrl}/${this.context}/delete/${id}`)
      .pipe(catchError((error: HttpErrorResponse) => this.handleError(error)));
  }

  create(createObject: T): Observable<T> {
    return this.http
      .post<T>(`${environment.apiUrl}/${this.context}`, {
        object: createObject
      })
      .pipe(catchError((error: HttpErrorResponse) => this.handleError(error)));
  }

  edit(id: number, editObject: T): Observable<T> {
    return this.http
      .patch<T>(`${environment.apiUrl}/${this.context}/${id}`, {
        object: editObject
      })
      .pipe(catchError((error: HttpErrorResponse) => this.handleError(error)));
  }

  private handleError(error: HttpErrorResponse) {
    const errorKeys = getHttpErrorTranslationKeys(error);

    this.messageCenterService.showToast(
      this.translate.instant(errorKeys.summary),
      this.translate.instant(errorKeys.detail),
      'error'
    );

    return throwError(() => error);
  }
}
